/*
 * Drawer - Regras apenas para produtos da coleção "fita-de-borda"
 * Mínimo: 10 | Incremento: 10
 * Blindado contra double-binding do tema (remove listeners do tema via clone)
 */
(function () {
  const TARGET_COLLECTIONS = window.collectionsWithMin10 || []; // ← vem do snippet Liquid
  const MIN = 10;
  const STEP = 10;

  // ---- util
  const norm = (v) => {
    let q = parseInt(v, 10);
    if (!Number.isFinite(q)) q = MIN;
    if (q < MIN) q = MIN;
    if (q % STEP !== 0) q = Math.round(q / STEP) * STEP;
    return q;
  };

  function stripAllListeners(btn) {
    if (!btn) return btn;
    if (btn.dataset.min10Stripped === "1") return btn; // já stripado
    const clone = btn.cloneNode(true);
    btn.replaceWith(clone);
    clone.dataset.min10Stripped = "1";
    return clone;
  }

  async function updateCartAjax(line, quantity) {
    try {
      console.log(`%c[MIN10] change.js line=${line} → ${quantity}`, "color:#00c853;font-weight:bold");
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity }),
      });
    } catch (err) {
      console.error("[MIN10] Erro no change.js", err);
    }
  }

  function isTargetCollectionItem(item) {
    const handles = (item.getAttribute("data-collection-handles") || "")
      .split(",")
      .map((h) => h.trim());
    const ok = TARGET_COLLECTIONS.some((c) => handles.includes(c));
    console.log(`[MIN10] item handles=(${handles.join("|")}) → ${ok ? "APLICA" : "ignora"}`);
    return ok;
  }

  function bindItemRules(item) {
    if (!isTargetCollectionItem(item)) return;

    const input = item.querySelector('input[name="updates[]"], input[name="quantity"]');
    if (!input) return;

    input.min = MIN;
    input.step = STEP;
    input.value = norm(input.value);

    const line = parseInt(input.dataset.index || input.getAttribute("data-index"), 10);

    // STRIP listeners do tema e depois bindar os nossos
    let plus = item.querySelector('button[name="plus"]');
    let minus = item.querySelector('button[name="minus"]');

    plus  = stripAllListeners(plus);
    minus = stripAllListeners(minus);

    if (plus && !plus.dataset.min10Bound) {
      plus.dataset.min10Bound = "1";
      plus.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const current = norm(input.value);
        const newQty  = current + STEP;
        console.log(`[MIN10] + ${current} → ${newQty}`);
        input.value = newQty;               // reflete imediato
        input.setAttribute("value", newQty);
        updateCartAjax(line, newQty);       // atualiza carrinho
      }, true); // capture = true
    }

    if (minus && !minus.dataset.min10Bound) {
      minus.dataset.min10Bound = "1";
      minus.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const current = norm(input.value);
        const newQty  = Math.max(MIN, current - STEP);
        console.log(`[MIN10] - ${current} → ${newQty}`);
        input.value = newQty;
        input.setAttribute("value", newQty);
        updateCartAjax(line, newQty);
      }, true);
    }

    if (!input.dataset.min10Bound) {
      input.dataset.min10Bound = "1";
      input.addEventListener("change", () => {
        const fixed = norm(input.value);
        console.log(`[MIN10] input manual → ${fixed}`);
        input.value = fixed;
        input.setAttribute("value", fixed);
        updateCartAjax(line, fixed);
      });
    }
  }

  function applyDrawerRules(root = document) {
    console.log("%c[MIN10] bind drawer…", "color:#ffab00;font-weight:bold");
    root.querySelectorAll(".cart-item").forEach(bindItemRules);
  }

  // observar o drawer
  const drawer = document.querySelector("#CartDrawer, .cart-drawer");
  if (drawer) {
    const obs = new MutationObserver(() => applyDrawerRules(drawer));
    obs.observe(drawer, { childList: true, subtree: true });
    applyDrawerRules(drawer);
  } else {
    console.warn("[MIN10] Drawer não encontrado");
  }
})();
